<h1 mat-dialog-title>{{'TOBA LIGHT.label.Category' | translate}}</h1>
<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <div mat-dialog-content>
        <div fxLayout="row wrap">
            <div fxFlex="100">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'TOBA LIGHT.label.name' | translate}}</mat-label>
                    <input matInput formControlName="name" required>
                    <mat-error *ngIf="form.controls.name.errors?.required">Name is required</mat-error>
                </mat-form-field>
            </div>
            <div fxFlex="100">
                <app-search-field [(myModel)]="selectedCategory" [options]="data.categories" [dataStructure]="{name:'name', value:'id', title:'TOBA LIGHT.category.parentCategory' | translate}" ></app-search-field>
            </div>
<!--            <div fxFlex="100">-->
<!--                <mat-form-field appearance="outline" class="w-100">-->
<!--                    <mat-label>{{'TOBA LIGHT.category.parentCategory' | translate}}</mat-label>-->
<!--                    <mat-select  [(value)]="selectedCategory">-->
<!--                        <mat-option [value]="null">-->
<!--                            <span>{{'TOBA LIGHT.category.option.null' | translate}}</span>-->
<!--                        </mat-option>-->
<!--                        <mat-option *ngFor="let cat of data.categories | sort :'name'" [value]="cat.id">-->
<!--                            <span>{{cat.name}}</span>-->
<!--                        </mat-option>-->
<!--                    </mat-select>-->
<!--                </mat-form-field>-->
<!--            </div>-->
            <div fxFlex="100">
               <mat-label>{{'TOBA LIGHT.label.name' | translate}}</mat-label>
               <p class="mt-1"><span class="uppercase fw-500">{{'TOBA LIGHT.slider.video' | translate}}</span><span class="text-muted px-1">{{'TOBA LIGHT.slider.maxImages' | translate}}</span></p>
               <input-file formControlName="image" (change)="fileUpload($event)" fileLimit="1" fileAccept="image/*"></input-file>
            </div>
            <div fxFlex="100" class="py-1">
                <mat-checkbox formControlName="hasSubCategory" color="primary">{{'TOBA LIGHT.category.hasSubCategory' | translate}}</mat-checkbox>
            </div>
        </div>
    </div>
    <div mat-dialog-actions>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100"> 
            <button mat-raised-button color="warn" type="button" mat-dialog-close>{{'TOBA LIGHT.label.close' | translate}}</button>
            <button mat-raised-button color="primary" type="submit">{{'TOBA LIGHT.label.save' | translate}}</button>
        </div> 
    </div>
</form>
